// extracted by mini-css-extract-plugin
export default {"ratioUersBody":"RatioUers_ratioUersBody__gsOAf"};